module.exports = "/static-assets/_next/static/images/user-agreement-9dbb815252f1ee622bdf045c1e0e344a.png";